import { distributionReasons, FullRegTypeCode, RegTypeCode } from './../../../shared/utilities/Constants';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import {
  UntypedFormBuilder, UntypedFormGroup, Validators
} from '@angular/forms';
import { Store, select } from '@ngrx/store';
import { DateTime } from 'luxon';
import { BehaviorSubject, Observable, Subject, combineLatest } from 'rxjs';
import { distinctUntilChanged, filter, map, take, takeUntil, withLatestFrom } from 'rxjs/operators';
import { AccountInfoState } from '../../../account-info-header/models/AccountInfoState';
import { selectAccountInfoSuccessfullyCompleted, selectAchInstructions, selectCashByAccountType, selectCreateWireTemplateCallCompleted, selectCreateWireTemplateCallSuccessful, selectHasGoingDigitalFlowInternalTransferCreateSloa, selectHeaderStateServiceError, selectInfo, selectIsBtMasterOnly, selectIsEmployee, selectIsEstateOrTestTrust, selectIsGuardianshipOrConservatorship, selectIsPtrs, selectIsTestamentaryTrust, selectIsValidRegType, selectLoadTransactionsCallFinished, selectMoveMoneyDataAccess, selectRegistrationType, selectSubAccountId, selectTemplateStartTransactionStarted, selectTemplatesListEmpty, selectTransactionAuthorizationDetails } from '../../../account-info-header/reducers';
import { selectHasAccessInitiateMoneyMovement, selectHasPositionLotsPhase2, selectHasPTRSViewFacility } from '../../../authorize/reducers';
import { displayCancelModal, resetCancelModal } from '../../../shared/actions/shared.actions';
import { AdobeHelpers } from '../../../shared/adobe-tagging/adobeHelper';
import { selectAchAcknowledgeErrorList, selectCancelModal, selectPageScrollTo, selectStandingAuthTableActionLinkState, selectStandingAuthTableStartTransactionClicked } from '../../../shared/reducers';
import { DrupalFormService } from '../../../shared/services/DrupalForm.service';
import { FeatureFlagService } from '../../../shared/services/feature-flag-service';
import { TableColumn } from '../../../shared/types/TableColumn';
import { selectedRowData } from '../../../shared/types/TableComponentState';
import { TransactionType } from '../../../shared/types/Transaction';
import { ApiEndpointType, Constants, NewRegTypes, digitalRegTypes, disableFieldsWhenEditFlow, fedTaxErrorMap, overdraftRulesPopupErrorTypes, overdraftRulesPopupErrors, positionConstants, transactionTypeLabels, transactionTypes } from '../../../shared/utilities/Constants';
import { CheckActions, InternalTransferActions, InternalTransfersActions, StandingAuthorizationsActions, TransactionFormActions, WireActions } from '../../actions';
import { updateFormValue } from '../../actions/transaction-form.action';
import { StandingAuthorizationsRequest } from '../../models/Standing-Authorizations';
import { FormControlRadio, RadioControl } from '../../models/form/FormControlRadio';
import { AchExtraPrompts, CheckTransactionDetails, ChecksExtraPrompts, ExtraPrompts, ItExtraPrompts, TransactionForm, TransactionFormServiceError, WireExtraPrompts, WireTransactionDetails, isWireExtraPrompts } from '../../models/form/TransactionForm';
import { InternalTransferInfo } from '../../models/internal-transfer/InternalTransferInfo';
import { RowDataById, ToAccountInfoById } from '../../models/internal-transfer/InternalTransfersInfo';
import { TransactionAuthorization } from '../../models/overview/TransactionAuthorization';
import { ServiceError } from '../../models/shared/ServiceError';
import { WarningOrError } from '../../models/shared/WarningOrError';
import { isRestrictedToAccountEntered, selectAchInputFinished, selectAchSelectedAuthorization, selectEditFLowFromTableComplete, selectFrequency, selectInquiryCallFailed, selectInternalTransferInfo, selectInternalTransfersHasServiceError, selectIsRecurring, selectItInputCallSuccessful, selectLoadToAccountError, selectMultipleToAccountsPositionLotTableData, selectPositionLotTableData, selectPositionsLotsTableState, selectPtrsInfo, selectShowCashieringIraAgreement, selectSpinnerStateForWireDetailsCall, selectStagedTransactionForm, selectStagedTransactionFormLoadingState, selectStandingAuthCallSucceededAch, selectToAccountsInfo, selectTransactionForm, selectTransactionFormPrefilledState, selectTransactionFormServiceError, selectTransactionType, selectTwe, selectVerifyCallFinished, selectVerifyErrorsByToAccount } from '../../reducers';
import { checkIfAllControlsAreValid, updateGroupValueAndValidity } from '../../utilities/formUtilities';
import { selectIsEnableRecurringChecksStandingAuth } from '../../../feature-flags/reducers';
@Component({
  standalone: false,
  selector: 'mm-transaction-form',
  templateUrl: './transaction-form.component.html',
  styleUrls: ['./transaction-form.component.scss'],
})
export class TransactionFormComponent implements OnInit, OnChanges, OnDestroy {
  @Output() showTweModal = new EventEmitter<boolean>();
  @Output() showTemplateModal = new EventEmitter<boolean>();
  @Output() showOverdraftRulesPopup = new EventEmitter<string>();
  @Output() formHasBeenStarted = new EventEmitter<boolean>();
  @Input() palAccountInContext = false;
  transactionForm: UntypedFormGroup;
  formValues$: Observable<unknown>;
  transactionFormState: TransactionForm;
  transactionFormSubmitted: TransactionForm;
  accountInfoState: AccountInfoState;
  itInfo: InternalTransferInfo;
  toAccountInfo: ToAccountInfoById | undefined;
  transactionAuthorizationDetails: TransactionAuthorization;
  prefilledForm: TransactionForm | undefined;
  prefilledPromptsObs = new BehaviorSubject<ExtraPrompts | null>(null);
  formSpinnerState$: Observable<{ loading: boolean; }>;
  editPageSpinnerState$: Observable<{ loading: boolean; }>;
  isEdit: boolean;
  transactionTypeControl: RadioControl = {
    title: 'Transaction type',
    controlName: 'transactionType',
    radios: [],
    validationMessage: 'Select a transaction type'
  };
  transactionType: string;
  readyForTransactionDetails$ = new BehaviorSubject<boolean>(false);
  focusPoint: string;
  achServiceError$: Observable<ServiceError>;
  overviewCallState$: Observable<ServiceError>;
  overviewCallFailureText = Constants.genericServiceError;
  destroy$ = new Subject<void>();
  hasMoveMoneyDataAccess: boolean | undefined;
  hasPTRSViewFacilityAccess: boolean | undefined;
  createRequestAccessDeniedText = Constants.createRequestAccessDeniedText;
  transactionFormServiceError$: Observable<TransactionFormServiceError>;
  hasServiceError: boolean = false;
  moneylinkInputError: boolean;
  inputCallFinished: boolean = false;
  ptrsCallFinished: boolean;
  isPtrs: boolean;
  registrationTypeToAcc: string;
  registrationType: string;
  isValidRegType: boolean | undefined;
  selectedRowDataInContext: selectedRowData;
  memoizedForm: TransactionForm;
  displayPositionsWarning: boolean = false;
  displayPositionsWarningPhase2: { displayWarning: boolean, toAccounts: string[], errorMessage: string; } = { displayWarning: false, toAccounts: [], errorMessage: '' };
  maxLotsWarningMessage: string[] = [];
  maxLotsWarning: { displayWarning: boolean; } = { displayWarning: false };
  standingAuthCallSucceededAch$: Observable<boolean>;
  achErrorList: WarningOrError[];
  hasHeaderStateError: boolean = false;
  isEmployee: boolean;
  showCashieringIraAgreement$: Observable<boolean>;
  transactionFormHeader: string = 'Create transaction';
  isEditSubmittedTransaction: boolean = false;
  isEditCurrentTransaction: boolean = false;
  isInquiryCallFailed: boolean = false;
  itInputCallSuccessful: boolean = false;
  positionLotsPhase2Enabled: boolean = false;
  positionLotsPhase2EnabledFsg: boolean = false;
  standingAuthId: string;
  isRecurringFrequencySelected: boolean;
  isCreateFromRecurringAchProfile: boolean;
  maxLotsAllowed = positionConstants.maxLotsAllowed;
  isTestamentaryTrust: boolean;
  newRegTypes = NewRegTypes;
  newRegTypesCheck = digitalRegTypes;
  availableCash: number;
  enableInterimIsoWires: boolean = false;
  isBtMasterOnly: boolean = false;
  isSpinnerLoadingForWireDetails: boolean;
  isISOCompliant: boolean;
  showOvernightWarning: boolean;
  hasItToAccountError: boolean;
  multipleVerifyErrors: string[] = [];
  showGenericServerError: boolean = false;
  genericserverErrorText: string = Constants.genericServiceError;
  saveAsTemplateCallSucceeded: boolean;
  isTemplateListEmpty: boolean;
  isInitRelease: boolean;
  selectedFrequency: string;
  isEstateOrTestTrust: boolean;
  isGuardianshipOrConservatorship: boolean;
  isRestrictedAccount: boolean;
  is401kToAccount: boolean;
  hasInternationalFedTaxError: boolean = false;
  overviewCallCompleted: boolean;
  accountInfoCallCompleted: boolean;
  palInfoBannerText = Constants.palTransactionInfoBannerText;
  enableRecurringChecksStandingAuth: boolean = false;

  constructor(
    private store: Store,
    private fb: UntypedFormBuilder,
    private featureFlagService: FeatureFlagService,
    private drupalFormService: DrupalFormService,
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    AdobeHelpers.trackPage('create_transaction', { 'user_selection': null });
    this.transactionForm = this.fb.group({
      transactionType: ['', Validators.required],
    });

    this.store.select(selectIsEnableRecurringChecksStandingAuth).pipe(takeUntil(this.destroy$)).subscribe(enableRecurringChecksStandingAuth => {
      this.enableRecurringChecksStandingAuth = enableRecurringChecksStandingAuth;
    });

    combineLatest([
      this.store.select(selectCreateWireTemplateCallCompleted),
      this.store.select(selectCreateWireTemplateCallSuccessful),
    ]).pipe(takeUntil(this.destroy$))
      .subscribe(([completed, successful]) => {
        this.saveAsTemplateCallSucceeded = successful;
      });

    this.store
      .select(selectSubAccountId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((_) => {
        // Next 2 lines - Only required for local development
        this.transactionFormHeader = 'Create transaction';
        this.transactionForm.enable();
        this.transactionForm.reset();
      });


    this.transactionForm.controls.transactionType.valueChanges.pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged()
    ).subscribe(val => {
      if (!!val) {
        this.store.dispatch(TransactionFormActions.TransactionTypeSelected());
      }
    });

    this.store.select(selectItInputCallSuccessful).pipe(takeUntil(this.destroy$)).subscribe((itInputCallSuccessful) => {
      this.itInputCallSuccessful = !!itInputCallSuccessful;
    });

    this.store.select(selectFrequency).pipe(takeUntil(this.destroy$)).subscribe((frequency) => {
      this.selectedFrequency = frequency ?? '';
    });

    this.store.select(selectToAccountsInfo).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.clearDisplayPositionsWarningPhase2();
      this.toAccountInfo = info;
      this.is401kToAccount = Object.values(this.toAccountInfo).some(value => (value?.registrationType === RegTypeCode.INDIVIDUAL_401K || value?.registrationType === RegTypeCode.ROTH_401K));
    });

    this.transactionForm.controls.transactionType.valueChanges.pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged(),
      withLatestFrom(this.store.select(selectStandingAuthTableStartTransactionClicked), this.store.select(selectTemplateStartTransactionStarted)),
    ).subscribe(([transactionType, startTransactionClickedTransaction, startTransactionClickedTemplate]) => {
      // When the user changes the transaction type, hide the transaction details
      this.store.dispatch(TransactionFormActions.initializeServiceError());
      this.transactionForm?.removeControl('extraPrompts');
      this.transactionForm?.removeControl('transactionDetails');
      if (!startTransactionClickedTransaction && !startTransactionClickedTemplate) {
        this.store.dispatch(TransactionFormActions.transactionTypeChanged({ transactionType: transactionType }));
        this.prefilledPromptsObs.next(null);
      }
      this.readyForTransactionDetails$.next(false);
      // If the transaction type doesn't match what's in the editForm, reset the editForm
      if (this.prefilledForm?.transactionType !== this.transactionFormState?.transactionType) {
        this.prefilledForm = undefined;
      }
      this.transactionType = transactionType;

      if (!startTransactionClickedTransaction && !this.isEdit && !startTransactionClickedTemplate) {
        if (this.transactionType === transactionTypes.ach) {
          this.callStandingAuthorizations();
        } else if (this.transactionType === transactionTypes.wire && !this.palAccountInContext) {
          this.callWireTemplatesGetList();
        }
      }
    });

    this.store.select(selectTransactionType).pipe(
      takeUntil(this.destroy$),
      map((transactionType) => {
        return transactionType !== '';
      }),
      distinctUntilChanged(),
    ).subscribe((transactionFormStarted) => {
      if (transactionFormStarted) {
        this.formHasBeenStarted.emit(true);
      } else {
        this.formHasBeenStarted.emit(false);
      }
    });

    this.standingAuthCallSucceededAch$ = this.store.select(selectStandingAuthCallSucceededAch);

    // NGRX - FORM MODEL SYNCING
    this.transactionForm.valueChanges.pipe(
      takeUntil(this.destroy$),
    ).subscribe(() => {
      const allValues = this.transactionForm.getRawValue();
      // we don't need form updates with no changes
      const isMemoized = JSON.stringify(allValues) === JSON.stringify(this.memoizedForm);
      if (!isMemoized) {
        const itExtraPrompts = this.memoizedForm?.extraPrompts as ItExtraPrompts;
        if (allValues?.extraPrompts?.transferType !== itExtraPrompts?.transferType && allValues?.transactionDetails?.toAccount &&
          (this.extraPrompts?.controls?.useStandingAuth?.value !== 'yes' && this.extraPrompts?.controls?.useStandingAuth?.value !== 'bundled')) {
          this.store.dispatch(InternalTransfersActions.itClearToAccounts());
          allValues.transactionDetails.toAccount = '';
          this.transactionDetailsFormGroup.patchValue({ toAccount: '' });
        }
        this.memoizedForm = allValues;
        this.store.dispatch(updateFormValue(allValues));
      }
    });

    this.transactionForm.statusChanges.pipe(
      takeUntil(this.destroy$),
      distinctUntilChanged(),
    ).subscribe((status: string) => {
      let valid: boolean = status === 'VALID';
      this.store.dispatch(TransactionFormActions.updateFormStatus({ valid }));
    });

    this.store.select(selectTransactionForm).pipe(
      takeUntil(this.destroy$)
    ).subscribe(form => {
      this.transactionFormSubmitted = form;
    });

    this.store.select(selectInfo).pipe(
      takeUntil(this.destroy$)
    ).subscribe(info => {
      this.accountInfoState = info;
      this.isPtrs = info.classifications.isPtrs;
    });

    this.formSpinnerState$ = combineLatest([
      this.store.select(selectIsPtrs),
      this.store.select(selectTransactionForm),
      this.store.select(selectPtrsInfo)]).pipe(
        map(([isPtrs, formState, ptrsInfo]) => {
          return isPtrs ? { loading: formState.loading || ptrsInfo.loading } : { loading: formState.loading };
        })
      );

    this.editPageSpinnerState$ = this.store.select(selectStagedTransactionFormLoadingState).pipe(
      map((isLoading => {
        return { loading: isLoading };
      }))
    );

    this.store.select(selectSpinnerStateForWireDetailsCall)
      .pipe(takeUntil(this.destroy$))
      .subscribe(isLoading => {
        this.isSpinnerLoadingForWireDetails = isLoading;
      });

    // select staged form here
    this.store.select(selectStagedTransactionForm).pipe(takeUntil(this.destroy$)).subscribe((form) => {
      this.transactionFormState = form;
    });

    this.store.select(selectEditFLowFromTableComplete).pipe(takeUntil(this.destroy$)).subscribe((isEditTransaction) => {
      this.isEditCurrentTransaction = isEditTransaction;
    });

    this.store.select(selectInquiryCallFailed).pipe(takeUntil(this.destroy$)).subscribe((isInquiryCallFailed) => {
      this.isInquiryCallFailed = isInquiryCallFailed;
    });

    this.store
      .select(selectTransactionFormPrefilledState)
      .pipe(
        takeUntil(this.destroy$),
      )
      .subscribe((prefilledFlowState) => {
        switch (prefilledFlowState.state) {
          case 'started':
            this.transactionForm.enable();
            this.transactionForm.reset();
            if (prefilledFlowState.name === 'edit-table') {
              this.transactionFormHeader = 'Edit transaction';
            }
            break;
          case 'inProgress':
            switch (prefilledFlowState.name) {
              case 'edit-review':
                this.isEdit = true;
                this.buildFormFromState(true);
                break;
              case 'edit-table':
                this.transactionFormHeader = 'Edit transaction';
                this.isEditSubmittedTransaction = true;
                this.buildFormFromState(true);
                break;
              default:
                break;
            }
            break;
          case 'complete':
            if (prefilledFlowState.name === 'edit-table') {
              this.disableControlsAfterPrefilledFlowComplete();
            }
            this.isEdit = false;
            break;
          default:
            this.transactionForm.enable();
            this.transactionFormHeader = 'Create transaction';
            this.isEditSubmittedTransaction = false;
            break;
        }
      });

    this.store
      .select(selectStandingAuthTableActionLinkState)
      .pipe(
        takeUntil(this.destroy$),
        filter(actionLink => actionLink.actionClicked),
        filter(actionLinkState => !(actionLinkState.actionName === 'Edit'))
      )
      .subscribe(actionLinkState => {
        this.transactionFormHeader = 'Create transaction';
        this.scrollToTop();
        this.transactionType = actionLinkState.selectedRowData.transactionType;
        this.selectedRowDataInContext = actionLinkState.selectedRowData;
        this.buildFormFromState(false);
      });

    this.store
      .select(selectTemplateStartTransactionStarted)
      .pipe(
        takeUntil(this.destroy$),
        filter((started) => started)
      )
      .subscribe(() => {
        this.ref.detectChanges(); //needed to re-initialize the wire-extra-prompts component when transactionType is updated too quickly in the template flows
        this.transactionFormHeader = 'Create transaction';
        this.scrollToTop();
        this.transactionType = 'wire';
        this.buildFormFromState(false, true);
      });

    this.store.select(selectTemplatesListEmpty).pipe(takeUntil(this.destroy$)).subscribe(isTemplateListEmpty => this.isTemplateListEmpty = isTemplateListEmpty);

    this.store.select(selectAchInputFinished).pipe(takeUntil(this.destroy$)).subscribe(callStatus => this.inputCallFinished = callStatus);
    this.transactionFormServiceError$ = this.store.select(selectTransactionFormServiceError);
    this.transactionFormServiceError$
      .pipe(takeUntil(this.destroy$))
      .subscribe((serviceError) => {
        this.hasServiceError =
          serviceError.hasError && !this.isMoneyLink400(serviceError) &&
          !this.isInternationalTaxError(serviceError) &&
          (this.isCreateTransactionSectionServiceError(serviceError.name) || this.isEditTransactionSectionServiceError(serviceError.name));
        this.moneylinkInputError =
          serviceError.name === ApiEndpointType.moneylinkInput;
        if (this.hasServiceError) {
          this.scrollToTop();
        }
      });

    this.store.select(selectVerifyErrorsByToAccount).pipe(takeUntil(this.destroy$), distinctUntilChanged((prev, curr) => curr.length === prev.length && curr.every((val, idx) => val === prev[idx]))).subscribe(multipleVerifyErrors => {
      this.multipleVerifyErrors = multipleVerifyErrors;
      multipleVerifyErrors.forEach(error => {
        if (error.toLowerCase().includes(fedTaxErrorMap.cashieringInternalTransferInternationalFedTaxError.toLowerCase())) {
          this.hasInternationalFedTaxError = true;
        }
      })
      if (multipleVerifyErrors.length > 0 && !this.hasInternationalFedTaxError) {
        this.scrollTo('multiple-validation-errors');
      }
    });

    this.store.select(selectInternalTransfersHasServiceError).pipe(takeUntil(this.destroy$)).subscribe(hasServiceError => {
      this.showGenericServerError = hasServiceError;
      if (hasServiceError) {
        this.scrollTo('generic-service-error-banner');
      }
    });

    this.store.select(selectHeaderStateServiceError).pipe(takeUntil(this.destroy$)).subscribe(error => {
      this.hasHeaderStateError = error;
    });

    this.store.pipe(
      takeUntil(this.destroy$),
      select(selectPageScrollTo)
    ).subscribe(val => {
      this.focusPoint = val;
      if (this.focusPoint === 'transaction-form-header') {
        this.scrollToTop();
      }
    });

    this.store.select(selectPtrsInfo).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.ptrsCallFinished = info.ptrsCallFinished;
    });

    combineLatest([
      this.store.select(selectTwe),
      this.store.select(selectVerifyCallFinished)
    ]).pipe(
      takeUntil(this.destroy$),
    ).subscribe(([tweInfo, verifyCallFinished]) => {
      if (verifyCallFinished && tweInfo.openTwePopup && !(this.multipleVerifyErrors.length > 0)) {
        this.showTweModal.emit(true);
      }
    });

    this.store.select(selectHasPTRSViewFacility).pipe(takeUntil(this.destroy$)).subscribe(hasPTRSViewFacilityAccess => {
      this.hasPTRSViewFacilityAccess = hasPTRSViewFacilityAccess;
    });

    this.store.select(selectMoveMoneyDataAccess).pipe(takeUntil(this.destroy$)).subscribe(hasMoveMoneyDataAccess => {
      this.hasMoveMoneyDataAccess = hasMoveMoneyDataAccess;
      setTimeout(() => {
        AdobeHelpers.trackClick('transactionFormPage_continueButton', 'linkid-lc_continue');
      }, 1);
    });

    combineLatest([
      this.store.select(selectHasAccessInitiateMoneyMovement),
    ]).pipe(
      takeUntil(this.destroy$),
    ).subscribe(([hasAccess]) => {
      this.isInitRelease = hasAccess;
    })

    this.store.select(selectLoadTransactionsCallFinished).pipe(takeUntil(this.destroy$)).subscribe(overViewCallSuccess => {
      this.overviewCallCompleted = !!overViewCallSuccess;
    });

    this.store.select(selectAccountInfoSuccessfullyCompleted).pipe(takeUntil(this.destroy$)).subscribe(accountInfoCallSuccess => {
      this.accountInfoCallCompleted = !!accountInfoCallSuccess;
    });

    combineLatest([
      this.store.select(selectLoadTransactionsCallFinished),
      this.store.select(selectTransactionAuthorizationDetails),
      this.store.select(selectIsEmployee),
      this.store.select(selectRegistrationType),
      this.store.select(selectIsValidRegType),
      this.store.select(selectAccountInfoSuccessfullyCompleted),
      this.store.select(selectIsEstateOrTestTrust),
      this.store.select(selectIsGuardianshipOrConservatorship),
      this.store.select(selectHasGoingDigitalFlowInternalTransferCreateSloa)
    ])
      .pipe(
        filter(([
          overviewCallSuccessful, _details, _value, _regType, _isValidRegType, accountInfoCallSuccess, _isEstateOrTestTrust, _isGuardianshipOrConservatorship,
          _hasGoingDigitalFlowInternalTransferCreateSloa,
        ]) => overviewCallSuccessful === true && accountInfoCallSuccess === true),
        takeUntil(this.destroy$),
      )
      .subscribe(([
        _overviewCallSuccessful, details, value, regType, isValidRegType, _accountInfoCallSuccess, isEstateOrTestTrust, isGuardianshipOrConservatorship,
        hasGoingDigitalFlowInternalTransferCreateSloa
      ]) => {
        this.overviewCallCompleted = true;
        this.accountInfoCallCompleted = true;
        this.transactionAuthorizationDetails = details;
        this.isEmployee = value;
        this.registrationType = regType;
        this.isValidRegType = isValidRegType;
        this.isEstateOrTestTrust = isEstateOrTestTrust;
        this.isGuardianshipOrConservatorship = isGuardianshipOrConservatorship;
        this.setTransactionTypes();
      });

    this.store.select(selectInternalTransferInfo).pipe(takeUntil(this.destroy$)).subscribe(itInfo => {
      this.registrationTypeToAcc = itInfo.toAccountInfo.registrationType;
    });

    this.store.select(selectAchAcknowledgeErrorList).pipe(takeUntil(this.destroy$)).subscribe(achAcknowledgeErrorList => {
      if (achAcknowledgeErrorList.length > 0) {
        this.achErrorList = achAcknowledgeErrorList;
      } else {
        this.achErrorList = [];
      }
    });

    this.store.select(selectPositionsLotsTableState).pipe(takeUntil(this.destroy$)).subscribe(info => {
      if (info.isInitialLoad === true) {
        this.displayPositionsWarning = false;
        this.maxLotsWarning.displayWarning = false;
        this.clearDisplayPositionsWarningPhase2();
      }
    });

    this.store.select(selectTransactionType).pipe(takeUntil(this.destroy$)).subscribe(info => {
      this.maxLotsWarning.displayWarning = false;
      this.displayPositionsWarning = false;
      this.clearDisplayPositionsWarningPhase2();
    });

    this.store.select(selectIsTestamentaryTrust).pipe(takeUntil(this.destroy$)).subscribe(isTestTrust => {
      this.isTestamentaryTrust = isTestTrust;
    });

    this.showCashieringIraAgreement$ = this.store.select(selectShowCashieringIraAgreement);

    this.store
      .select(selectCancelModal)
      .pipe(
        takeUntil(this.destroy$),
        filter((modal) => modal.source !== 'StandingAuthTableStartTransaction' && modal.continueClicked)
      )
      .subscribe(({ continueClicked }) => {
        this.resetForm(continueClicked);
        this.store.dispatch(resetCancelModal());
      });

    this.store.select(selectIsRecurring).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.isRecurringFrequencySelected = val;
    });

    this.store.select(selectCashByAccountType).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.availableCash = typeof val[0].amount === 'number' ? val[0].amount : 0;
    });
    this.store.select(selectHasPositionLotsPhase2).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.positionLotsPhase2EnabledFsg = val;
    });

    this.store.select(selectIsBtMasterOnly).pipe(takeUntil(this.destroy$)).subscribe(val => {
      this.isBtMasterOnly = val;
    });

    this.store.select(selectLoadToAccountError).pipe(
      takeUntil(this.destroy$)
    ).subscribe(error => {
      this.hasItToAccountError = error === '' ? false : true;
    });

    this.store.select(isRestrictedToAccountEntered).pipe(takeUntil(this.destroy$)).subscribe(isRestricted => {
      this.isRestrictedAccount = isRestricted;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['palAccountInContext']?.currentValue === true) {
      this.setTransactionTypes();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  disableControlsAfterPrefilledFlowComplete(): void {
    if (this.transactionType == null && this.isEditCurrentTransaction && this.isInquiryCallFailed) {
      this.transactionForm.get('transactionType')?.disable({ emitEvent: false });
      this.transactionForm.get('transactionType')?.clearValidators();
    }

    disableFieldsWhenEditFlow[this.transactionType as TransactionType].forEach(
      (elem) => {
        this.transactionForm.get(elem)?.disable({ emitEvent: false });
      }
    );
  }

  isCreateTransactionSectionServiceError(name: string): boolean {
    return (
      name === ApiEndpointType.moneylinkInput ||
      name === ApiEndpointType.standingAuthorizations ||
      name === ApiEndpointType.moneylinkVerify ||
      name === ApiEndpointType.wireInputV3 ||
      name === ApiEndpointType.wireVerifyV3 ||
      name === ApiEndpointType.internalTransferInput ||
      name === ApiEndpointType.internalTransferVerify ||
      name === ApiEndpointType.checkInput ||
      name === ApiEndpointType.checkVerify
    );
  }

  isMoneyLink400(error: TransactionFormServiceError): boolean {
    return error.url.includes("MoneyLinkVerify") && error.status.toString() === '400';
  }

  isInternationalTaxError(error: TransactionFormServiceError): boolean {
    if (!error.hasError || !error.errorList) {
      return false;
    }

    return error.errorList.some(errorItem => {
      const errorMessage = errorItem.detail?.toLowerCase() || '';
      return errorMessage === fedTaxErrorMap.cashieringinternationFedTaxError.toLowerCase();
    });
  }

  isEditTransactionSectionServiceError(name: string): boolean {
    return (
      name === ApiEndpointType.checkInquiry ||
      name === ApiEndpointType.transInquiry ||
      name === ApiEndpointType.internalTransferInquiry
    );
  }

  get extraPrompts(): UntypedFormGroup {
    return this.transactionForm?.controls?.extraPrompts as UntypedFormGroup;
  }

  get transactionDetails(): UntypedFormGroup {
    return this.transactionForm?.controls?.transactionDetails as UntypedFormGroup;
  }

  onCancelClick(): void {
    if (this.transactionForm?.controls?.transactionType.value || this.isEditCurrentTransaction) {
      this.store.dispatch(displayCancelModal({
        nextUrlState: '',
        title: 'Cancel transaction in progress',
        content: ['Canceling will reset your transaction inputs. Are you sure you want to continue?'],
        greenButton: 'Cancel transaction',
        grayButton: 'Back',
        isQuicklinksNav: false,
        source: 'transactionInputPage'
      }));
    }
  }

  callStandingAuthorizations() {
    let standingAuthRequest: StandingAuthorizationsRequest = {
      subAccountId: this.accountInfoState.accountId,
      masterAccountId: this.accountInfoState.masterAccount,
      sloaType: "A"
    };
    this.store.dispatch(StandingAuthorizationsActions.loadSloas(standingAuthRequest));
  }

  callWireTemplatesGetList() {
    this.store.dispatch(WireActions.callWireTemplatesGetList());
  }

  isPositionsTransaction(): boolean {
    return this.extraPrompts?.controls?.transferType?.value === 'positions' || this.extraPrompts?.controls?.transferType?.value === 'positionsCash';
  }
  showMultipleToAccount() {
    if (typeof this.featureFlagService.featureFlags.positionLotsPhase2Enabled === 'boolean' && !this.positionLotsPhase2Enabled) {
      this.positionLotsPhase2Enabled = this.featureFlagService.featureFlags.positionLotsPhase2Enabled || this.positionLotsPhase2EnabledFsg;
    }
    return this.isPositionsTransaction() && this.positionLotsPhase2Enabled;
  }

  hasPositionTablePhase2Error() {
    var hasError = false;
    this.maxLotsWarning.displayWarning = false;
    this.store.pipe(select(selectMultipleToAccountsPositionLotTableData), take(1)).subscribe((multipleToAccountsPositionLotTableData) => {
      if (this.checkAndSetPositionTableUserInputError(multipleToAccountsPositionLotTableData) || this.checkAndSetPositionTableNoPositionSelectedError(multipleToAccountsPositionLotTableData) || this.checkAndSetPositionTableMaxLotsExceededError(multipleToAccountsPositionLotTableData)) {
        hasError = true;
      }
    });
    return hasError;
  }

  countCurrentLots(element: any) {
    var currentLots = 0;
    element['lotDetail'].forEach((lot: any) => {
      if (lot['lotsToMove'] !== '' && lot['lotsToMove'] !== undefined) {
        currentLots++;
      }
    });
    return currentLots;
  }
  updateMaxLotsWarningMessageMap(map: Map<string, string[]>, key: string, value?: string): void {
    if (!map.has(key)) {
      map.set(key, []);
    }
    if (value) {
      const array = map.get(key) || [];
      array.push(value);
      map.set(key, array);
    }
  }
  formatMaxLotsWarningMessage(map: Map<string, string[]>) {
    map.forEach((values, key) => {
      let valuesWithHash = values.map(value => '#' + value);
      var valueString = valuesWithHash.join(', ');
      this.maxLotsWarningMessage.push('<b>' + key + '</b>' + ' (' + valueString + '); ');
    });
  }

  checkAndSetPositionTableUserInputError(positionTableData: RowDataById) {
    let hasError = Object.keys(positionTableData).some(toAccount =>
      positionTableData[toAccount].positionData.some(position =>
        position.hasError || position.lotDetail.some((lot: any) => lot.lotHasError && lot.lotHasError > 0)
      )
    );
    if (hasError) {
      this.displayPositionsWarningPhase2.errorMessage = Constants.positionTableUserInputError;
      this.displayPositionsWarningPhase2.displayWarning = true;
    }
    else {
      this.displayPositionsWarningPhase2.errorMessage = "";
      this.displayPositionsWarningPhase2.displayWarning = false;
    }
    return hasError;
  }

  checkAndSetPositionTableMaxLotsExceededError(toAccounts: RowDataById) {
    let warningMessageInfoMap = new Map<string, string[]>();
    this.maxLotsWarningMessage = [];
    this.maxLotsWarning.displayWarning = false;
    let showError = false;
    Object.keys(toAccounts).forEach(toAccount => {
      toAccounts[toAccount].positionData.forEach(element => {
        if (element['lotDetail'].length > this.maxLotsAllowed && toAccounts[toAccount].nodeCostBasis === 'None') {
          var currentLots = this.countCurrentLots(element);
          if (currentLots > this.maxLotsAllowed) {
            showError = true;
            this.updateMaxLotsWarningMessageMap(warningMessageInfoMap, element['Symbol'], toAccount);
          }
        }
      });
    });
    if (showError) {
      this.maxLotsWarning.displayWarning = true;
    }
    else {
      this.maxLotsWarning.displayWarning = false;
    }
    this.formatMaxLotsWarningMessage(warningMessageInfoMap);
    return showError;
  }

  checkMaxLotsErrorPhase1(rowData: TableColumn[]) {
    this.maxLotsWarningMessage = [];
    this.maxLotsWarning.displayWarning = false;
    rowData.forEach(element => {
      if (element['lotDetail'].length > this.maxLotsAllowed && element['nodeCostBasis'] === 'None') {
        var currentLots = this.countCurrentLots(element);
        if (currentLots > this.maxLotsAllowed) {
          this.maxLotsWarning.displayWarning = true;
          this.maxLotsWarningMessage.push(element['Symbol'] + ' has ' + currentLots + ' lots, ');
        }
      }
    });
  }

  onSaveTemplateClick(): void {
    if (this.transactionForm.valid) {
      this.showTemplateModal.emit(true);
    } else {
      this.transactionForm.markAllAsTouched();
      updateGroupValueAndValidity(this.transactionForm);
      this.store.dispatch(TransactionFormActions.continueClickInvalid());
    }
  }

  onContinueClick(): void {
    if (this.transactionForm.valid) {
      switch (this.transactionForm.controls.transactionType.value) {
        case transactionTypes.ach:
          if (!this.transactionFormSubmitted.serviceError.hasError || this.transactionFormSubmitted.serviceError.name === ApiEndpointType.moneylinkVerify) {
            combineLatest([
              this.store.select(selectAchInstructions),
              this.store.select(selectAchSelectedAuthorization)
            ]).pipe(
              takeUntil(this.destroy$),
            ).subscribe(([achInstructions, selectedAchProfile]) => {
              let selectedAuthorization = selectedAchProfile?.split('-')[1];
              achInstructions.forEach((instruction) => {
                if (instruction.cashieringRqstId === selectedAuthorization) {
                  let hasFrequency = instruction.frequencyDescription != null && instruction.frequencyDescription != undefined;
                  this.isCreateFromRecurringAchProfile = instruction.isRecurring || hasFrequency;
                }
              });
            });
            if (this.isAddAchRecurringProfile || this.isAddAchOnRequestProfile) {
              this.store.dispatch(TransactionFormActions.callAchAddProfileVerify({ transactionForm: this.transactionFormSubmitted }));
            } else {
              this.store.dispatch(TransactionFormActions.callAchVerify(this.transactionFormSubmitted));
            }
          }
          break;
        case transactionTypes.internalTransfer:
          if (this.hasItToAccountError) this.scrollTo('it-download-request-form-error-banner');
          if ((this.extraPrompts?.controls?.transferType?.value === 'positions' || this.extraPrompts?.controls?.transferType?.value === 'positionsCash') && (!this.is401kToAccount || this.selectedFrequency === "onetimeTotalDist")) {
            if (this.showMultipleToAccount()) {
              if (this.hasPositionTablePhase2Error()) {
                this.scrollTo('errorBanners');
              }
              else {
                if (this.selectedFrequency === "onetimeTotalDist") {
                  this.store.dispatch(TransactionFormActions.continueClickTotalDist({ transactionForm: this.transactionFormSubmitted }));
                }
                else {
                  this.store.dispatch(TransactionFormActions.callInternalTransferListVerify({ transactionForm: this.transactionFormSubmitted }));
                }
              }
              break;
            } else {
              this.store.pipe(select(selectPositionLotTableData), take(1)).subscribe((rowData) => {
                this.displayPositionsWarning = !(rowData.filter(position => position['Shares to move'] !== '').length > 0);
                this.checkMaxLotsErrorPhase1(rowData);
                if (this.maxLotsWarningMessage.length > 0) {
                  this.maxLotsWarningMessage[this.maxLotsWarningMessage.length - 1] = this.maxLotsWarningMessage[this.maxLotsWarningMessage.length - 1].replace(',', '.');
                }
                if (!this.displayPositionsWarning && !this.maxLotsWarning.displayWarning && !Array.from(document.querySelectorAll('[id^="errorText"]')).some(node => node.innerHTML)) {
                  this.store.dispatch(TransactionFormActions.callInternalTransferVerify({ transactionForm: this.transactionFormSubmitted, isInRViewReviewFlow: false }));
                }
                else {
                  this.transactionForm.markAllAsTouched();
                  updateGroupValueAndValidity(this.transactionForm);
                  this.store.dispatch(TransactionFormActions.continueClickInvalid());
                }
              });
              break;
            }
          } else if (this.is401kToAccount && this.hasPositionTablePhase2Error()) {
            this.scrollTo('errorBanners');
            break;
          } else {
            // do not dispatch verify call unless input call completed successfully or is edit submitted flow
            if (
              (this.itInputCallSuccessful || this.isEditSubmittedTransaction) &&
              (!this.transactionFormSubmitted?.serviceError?.hasError ||
                this.transactionFormSubmitted?.serviceError?.name ===
                ApiEndpointType.internalTransferVerify)
            ) {
              if (this.is401kToAccount) {
                let details = this.transactionFormSubmitted.transactionDetails as CheckTransactionDetails;
                let today: string = DateTime.now().toFormat('MM/dd/yyyy');
                if (details.processDate === today &&
                  this.availableCash < Number.parseFloat(details.amount?.substring(1) ?? '0')) {
                  this.store.dispatch(InternalTransferActions.nsfClientSideError());
                } else {
                  this.store.dispatch(TransactionFormActions.loadInternalTransferWithoutVerifyCall(this.transactionFormSubmitted));
                }
              } else {
                this.store.dispatch(
                  TransactionFormActions.callInternalTransferVerify(
                    { transactionForm: this.transactionFormSubmitted, isInRViewReviewFlow: false }
                  )
                );
              }
            }
            break;
          }
        case transactionTypes.wire:
           if ((!this.transactionFormSubmitted.serviceError.hasError || this.transactionFormSubmitted.serviceError.name === ApiEndpointType.wireVerifyV3) &&
             !this.isSpinnerLoadingForWireDetails) {
             this.store.dispatch(TransactionFormActions.callWiresVerifyV3(this.transactionFormSubmitted));
           }
          break;
        case transactionTypes.check:
          const frequency: string = this.extraPrompts?.controls.frequency?.value ?? '';
          const isBSLOARecurringTransaction: boolean = this.extraPrompts?.controls.useBundledStandingAuth?.value === 'recurring';
          const isBundledOneTimeTotalDist: boolean = this.extraPrompts?.controls.useBundledStandingAuth?.value === 'onetimeTotalDist';
          const isSloaOneTimeTotalDist: boolean = this.extraPrompts?.value?.useStandingAuth === 'yes' && this.extraPrompts?.value?.frequency === 'onetimeTotalDist';

          if (this.selectedFrequency === "onetimeTotalDist" || isBundledOneTimeTotalDist || isSloaOneTimeTotalDist) {
            if (this.transactionFormSubmitted && this.transactionFormSubmitted?.transactionDetails) {
              this.transactionFormSubmitted = {
                ...this.transactionFormSubmitted,
                transactionDetails: {
                  ...this.transactionFormSubmitted.transactionDetails,
                  amount: Constants.checksTotalDistributionAmountText  //Setting amount to a constant text when 'oneTimeTotalDist' is selected as frequency
                }
              };
            }
            this.store.dispatch(TransactionFormActions.continueClickTotalDist({ transactionForm: this.transactionFormSubmitted }));
          }
          else if (frequency === 'recurring' || isBSLOARecurringTransaction) {
            this.store.dispatch(TransactionFormActions.callRecurringCheckVerify(this.transactionFormSubmitted));
            break;
          } else {
            this.store.dispatch(TransactionFormActions.callOnetimeCheckVerify(this.transactionFormSubmitted));
            break;
          }
      }
    } else {
      if (this.extraPrompts?.controls?.transferType?.value === 'positions' || this.extraPrompts?.controls?.transferType?.value === 'positionsCash') {
        if (this.showMultipleToAccount()) {
          this.store.pipe(select(selectMultipleToAccountsPositionLotTableData), take(1)).subscribe((positionData) => {
            let showError = this.checkAndSetPositionTableNoPositionSelectedError(positionData);
            if (showError) {
              this.scrollTo('errorBanners');
            }
            this.displayPositionsWarningPhase2.displayWarning = showError;
          });
          if (this.isReportsStatementsInvalid()) {
            this.scrollTo('reports-statements-section');
          }
        }
        else {
          this.store.pipe(select(selectPositionLotTableData), take(1)).subscribe((rowData) => {
            this.displayPositionsWarning = false;
            if (rowData.filter(position => position['Shares to move'] !== '').length === 0) {
              this.displayPositionsWarning = true;
            }
          });
        }
      }
      this.transactionForm.markAllAsTouched();
      updateGroupValueAndValidity(this.transactionForm);

      /* Only emit when all controls in transactionDetails formGroup are valid
        and transactionDetails formGroup has overdraft popup error.
        We don't want popup displayed when individual controls are invalid. */
      if (this.verifyOverdraftOverride && this.isPtrs) {
        this.showOverdraftRulesPopup.emit(this.overdraftPopupRulesError);
      }
      this.store.dispatch(TransactionFormActions.continueClickInvalid());

      setTimeout(() => {
        const errorLabels = document.getElementsByClassName('error-text');
        if (errorLabels.length > 0) {
          const firstErrorEl = errorLabels[0] as HTMLElement;
          firstErrorEl?.focus();
          firstErrorEl?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
        }
      }, 150);
    }
  }

  onExtrasCompleted(completed: boolean): void {
    this.readyForTransactionDetails$.next(completed);
  }

  checkAndSetPositionTableNoPositionSelectedError(positionData: RowDataById) {
    this.displayPositionsWarningPhase2.toAccounts = [];
    this.displayPositionsWarningPhase2.errorMessage = '';
    let toAccounts = Object.keys(positionData);
    let response = false;
    Object.keys(positionData).forEach((toAccount) => {
      let movingPositions = false;
      positionData[toAccount].positionData.forEach(position => {
        if (position['Shares to move'] !== '' && position['Shares to move'] !== undefined) {
          movingPositions = true;
        }
      });
      if (!movingPositions) {
        this.displayPositionsWarningPhase2.toAccounts.push(toAccount);
        response = true;
      }
    });
    let allAccountsHaveNoPositions = this.displayPositionsWarningPhase2.toAccounts.length == toAccounts.length;
    if (response) {
      this.createErrorMessage(allAccountsHaveNoPositions);
    }
    if (response && !this.isRestrictedAccount) {
      this.displayPositionsWarningPhase2.displayWarning = true;
    }
    else {
      this.displayPositionsWarningPhase2.displayWarning = false;
      this.displayPositionsWarningPhase2.errorMessage = "";
    }
    return response;
  }

  createErrorMessage(allAccountsHaveNoPositions: boolean) {
    if (allAccountsHaveNoPositions) {
      this.displayPositionsWarningPhase2.errorMessage = "<p class='positionsMissingText'>" + positionConstants.SelectPositionErrorMessagePhase2 + "</p>";
    }
    else {
      let error = "<p class='positionsMissingError'>" + positionConstants.SelectToAccountsPositionErrormessagePhase2 + "</p>";
      this.displayPositionsWarningPhase2.toAccounts.forEach(account => {
        let name = this?.toAccountInfo?.[account].accountRegistration.length == 0 ? '' : this?.toAccountInfo?.[account].accountRegistration[0] + ' ';
        let regType = this?.toAccountInfo?.[account].regTypeShortName;
        let span = "<span class='positionsMissingText'>" + name + '(' + account + ' | ' + regType + '); ' + "</span>";
        error = error + span;
      });
      this.displayPositionsWarningPhase2.errorMessage = error;
    }
  }

  clearDisplayPositionsWarningPhase2() {
    this.displayPositionsWarningPhase2.displayWarning = false;
    this.displayPositionsWarningPhase2.errorMessage = '';
    this.displayPositionsWarningPhase2.toAccounts = [];
  }

  //TODO: reset function needed - when transactionSelector is dirty/touched and changes - call reset o the form and remove extraPrompts + transactionDetails
  resetForm(reset: boolean): void {
    if (reset) {
      this.scrollToTop();
      this.transactionForm?.removeControl('extraPrompts');
      this.transactionForm?.removeControl('transactionDetails');
      this.transactionForm?.reset();
      this.store.dispatch(TransactionFormActions.cancelClicked()); // When cancel is clicked, set isEdit back to false
    }
  }

  buildFormFromState(isEdit: boolean, isTemplate: boolean = false): void {
    if (this.transactionFormState && isEdit) {
      // Create a copy of transactionFormState so that we can preserve the values since transactionFormState is going to be reset once we modify the form values
      this.prefilledForm = this.transactionFormState;
      // Only need to set the transaction type here, our other components will handle the rest
      this.transactionForm.controls.transactionType.setValue(this.transactionFormState.transactionType);
    }
    else if (isTemplate && isWireExtraPrompts(this.transactionFormState.extraPrompts!)) {
      this.transactionForm.enable();
      this.transactionForm.controls.transactionType.setValue(this.transactionType);
      this.prefilledPromptsObs.next(this.transactionFormState.extraPrompts);
    } else {
      this.transactionForm.controls.transactionType.setValue(this.transactionType);

      // Change behavior subject value based on the rowData in context (tranaction type)
      if (this.selectedRowDataInContext.transactionType === transactionTypes.ach) {
        this.callStandingAuthorizations();
        let extraPrompts: AchExtraPrompts = {
          transferDirection: this.selectedRowDataInContext.transferDirection ?? '',
          standingAuthId: this.selectedRowDataInContext.standingAuthId
        };
        this.prefilledPromptsObs.next(extraPrompts);
      } else if (this.selectedRowDataInContext.transactionType === transactionTypes.wire) {
        let extraPrompts: WireExtraPrompts;
        if (this.selectedRowDataInContext.isBundled) {
          extraPrompts = {
            useStandingAuth: 'bundled',
            useBundledStandingAuth: 'yes',
            standingAuthId: this.selectedRowDataInContext.standingAuthId
          };
        } else {
          extraPrompts = {
            useStandingAuth: 'yes',
            standingAuthId: this.selectedRowDataInContext.standingAuthId
          };
        }
        this.prefilledPromptsObs.next(extraPrompts);
      } else if (this.selectedRowDataInContext.transactionType === transactionTypes.internalTransfer) {
        let extraPrompts: ItExtraPrompts;
        if (this.selectedRowDataInContext.isBundled) {
          extraPrompts = {
            useStandingAuth: 'bundled',
            useBundledStandingAuth: 'yes',
            standingAuthId: this.selectedRowDataInContext.standingAuthId
          };
        } else {
          extraPrompts = {
            useStandingAuth: 'yes',
            standingAuthId: this.selectedRowDataInContext.standingAuthId
          };
        }
        this.prefilledPromptsObs.next(extraPrompts);
      } else if (this.selectedRowDataInContext.transactionType === transactionTypes.check) {
        let extraPrompts: ChecksExtraPrompts;
        if (this.selectedRowDataInContext.isBundled) {
          extraPrompts = {
            useStandingAuth: 'bundled',
            useBundledStandingAuth: 'yes',
            standingAuthId: this.selectedRowDataInContext.standingAuthId
          };
        } else {
          extraPrompts = {
            useStandingAuth: 'yes',
            standingAuthId: this.selectedRowDataInContext.standingAuthId
          };
        }
        this.prefilledPromptsObs.next(extraPrompts);
      }
    }
  }

  onExtraPromptsUpdated(): void {
    this.prefilledForm = undefined;
  }

  scrollToTop(): void {
    const elem = document.getElementById('transaction-form-header');
    setTimeout(() => {
      elem?.focus();
      elem?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    });
  }

  scrollTo(elemName: string) {
    setTimeout(() => {
      const bannerEl = document.getElementById(elemName);
      bannerEl?.focus();
      bannerEl?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'start' });
    }, 100);
  }

  setShowOvernightWarningEvent(showOvernightWarning: boolean): void {
    this.showOvernightWarning = showOvernightWarning;
  }

  isReportsStatementsInvalid(): boolean {
    const taxFormsDateInputControl = this.extraPrompts?.controls?.taxFormsDateInputControl;
    const accountStatementsDateInputControl = this.extraPrompts?.controls?.accountStatementsDateInputControl;
    const tradeConfirmationsDateInputControl = this.extraPrompts?.controls?.tradeConfirmationsDateInputControl;
    const isReportsStatementsSectionInvalid =
      (taxFormsDateInputControl && taxFormsDateInputControl.invalid) ||
      (accountStatementsDateInputControl && accountStatementsDateInputControl.invalid) ||
      (tradeConfirmationsDateInputControl && tradeConfirmationsDateInputControl.invalid);
    return isReportsStatementsSectionInvalid;
  }

  get verifyOverdraftOverride(): boolean {
    if (this.transactionDetailsFormGroup && this.transactionDetailsFormGroup.errors) {
      // Checks if all controls in transactionDetails formGroup are valid
      if (checkIfAllControlsAreValid(this.transactionDetailsFormGroup)) {
        return this.overdraftPopupRulesError?.length > 0;
      }
    }
    return false;
  }

  get overdraftPopupRulesError(): string {
    if (this.transactionDetailsFormGroup && this.transactionDetailsFormGroup.errors) {
      const errorKeys: string[] = Object.keys(this.transactionDetailsFormGroup.errors ?? {});
      return errorKeys.length > 0 ? overdraftRulesPopupErrors[errorKeys[0] as overdraftRulesPopupErrorTypes] : '';
    }
    return '';
  }

  get transactionDetailsFormGroup() {
    return this.transactionForm.controls?.transactionDetails as UntypedFormGroup;
  }

  get displayAchTransactionDetails(): boolean {
    if (this.isPtrs) {
      return !this.moneylinkInputError && this.inputCallFinished && this.ptrsCallFinished;
    }
    return !this.moneylinkInputError && this.inputCallFinished;
  }

  get showUnauthorizedAccess(): boolean {
    if (!this.overviewCallCompleted || !this.accountInfoCallCompleted) return false;
    return (!this.hasMoveMoneyDataAccess || !this.isValidRegType)
      && !this.isEmployee;
  }

  get showAccessDeniedBanner(): string {
    if (!this.hasMoveMoneyDataAccess) {
      return Constants.transactionUnauthorized;
    } else if (!this.isValidRegType) {
      return Constants.accountIneligible;
    }
    return '';
  }

  get showPTRSDenied(): boolean {
    if (!this.overviewCallCompleted || !this.accountInfoCallCompleted) return false;
    return (!this.hasPTRSViewFacilityAccess && this.isPtrs) && !this.isEmployee;
  }

  get showPTRSDeniedBanner(): string {
    if (!this.hasPTRSViewFacilityAccess && this.isPtrs) {
      return Constants.ptrsUnauthorized;
    }
    return '';
  }

  get isAddAchRecurringProfile(): boolean {
    //Create Recurring ACH from Recurring or On-Request ACH profile
    return this.isRecurringFrequencySelected;
  }

  get isAddAchOnRequestProfile(): boolean {
    //Create On-Request ACH from Recurring ACH profile
    return (!this.isRecurringFrequencySelected && this.isCreateFromRecurringAchProfile);
  }

  getDrupalPdf(name: string) {
    this.drupalFormService.createDrupalForm(name);
  }

  get isEditRecurringSubmittedCheckTransaction(): boolean {
    const rawTransactionType = this.transactionForm?.controls?.transactionType?.value;
    const transactionTypeValue = typeof rawTransactionType === 'string'
    ? rawTransactionType.toLowerCase() : '';

    return this.enableRecurringChecksStandingAuth
      && transactionTypeValue === transactionTypes.check
      && this.isEditSubmittedTransaction
      && this.isRecurringFrequencySelected;
  }


  get showSaveTemplateButton(): boolean {
    return (
      this.transactionType === 'wire'
      && (this.isTemplateListEmpty ?
        this.extraPrompts?.controls?.useStandingAuth?.value === 'no' :
        this.extraPrompts?.controls?.useStandingAuth?.value === 'no' && this.extraPrompts?.controls?.useTemplates?.value === 'no')
      && this.saveAsTemplateCallSucceeded != true
    );
  }

  private setTransactionTypes(): void {
    // Clear all existing radios first
    this.transactionTypeControl.radios = [];

    // Helper to add a radio with optional warning
    const addRadio = (type: string, label: string[], index: number, warningText?: string, disabled?: boolean): void => {
      const radio: any = { value: type, label: label };
      if (warningText) radio.warning = { text: warningText, displayBelow: false };
      if (disabled) radio.disabled = true;
      this.transactionTypeControl.radios.splice(index, 0, radio);
    };

     if (this.palAccountInContext) {
      addRadio(transactionTypes.wire, [transactionTypeLabels.wire], 0);
      return;
    }

    // --- ACH ---
    // Add warning and disable for estate, test trust, or guardianship/conservatorship accounts
    const achShouldDisable = this.isEstateOrTestTrust || this.isGuardianshipOrConservatorship;
    const achOtherReg = (!achShouldDisable && this.transactionAuthorizationDetails.moneylinkAuthorization.length == 0);
    const achWarningText = achShouldDisable
      ? Constants.transactionTypeNotSupported
      : achOtherReg ? Constants.transactionTypeUnauthorized : undefined;
    const achDisabled = !!achShouldDisable || !!achOtherReg;
    addRadio(transactionTypes.ach, [transactionTypeLabels.ach], 0, achWarningText, achDisabled);

    // --- Internal Transfer ---
    // Add warning and disable for ineligible accounts and when array is empty
    const internalShouldDisable = (this.transactionAuthorizationDetails?.journalAuthorization?.length == 0);
    const internalTransferWarningText = internalShouldDisable ? Constants.transactionTypeUnauthorized : undefined;
    const internalDisable = !!internalShouldDisable;
    addRadio(transactionTypes.internalTransfer, [transactionTypeLabels.internalTransfer], 1, internalTransferWarningText, internalDisable);

    // --- Check ---
    // Add warning and disable for ineligible accounts and when array is empty
    const checkShouldDisable = (this.transactionAuthorizationDetails?.checkAuthorization?.length == 0);
    const checkWarningText = checkShouldDisable ? Constants.transactionTypeUnauthorized : undefined;
    const checkDisable = !!checkShouldDisable;
    addRadio(transactionTypes.check, [transactionTypeLabels.check], 2, checkWarningText, checkDisable);

    // --- Wire ---
    // Add warning and disable for guardianship/conservatorship accounts
    const wireShouldDisable = this.isGuardianshipOrConservatorship;
    const wireOtherReg = (!wireShouldDisable && !this.isEstateOrTestTrust && this.transactionAuthorizationDetails?.wireAuthorization?.length == 0);
    const wireWarningText = wireShouldDisable
      ? Constants.transactionTypeNotSupported
      : wireOtherReg ? Constants.transactionTypeUnauthorized : undefined;
    const wireDisabled = !!wireShouldDisable || !!wireOtherReg;
    addRadio(transactionTypes.wire, [transactionTypeLabels.wire], 3, wireWarningText, wireDisabled);
  }
}
